import React from 'react';
import { GovSkeleton } from '@gov-design-system-ce/react';
import { useGlobalLocale } from '@gov-nx/core/service';
import { LayoutGap } from '@gov-nx/ui/web';
import { generateRandomNumber } from '@gov-nx/utils/common';

export const DocumentSkeleton = () => {
	const { t } = useGlobalLocale();

	return (
		<div className="p-5">
			<GovSkeleton
				width={generateRandomNumber(20, 60) + '%'}
				height="24px"
				aria-label={t('loading.wcag.processing')}
			/>
			<div className="flex flex-col items-start gap-4 [ sm:flex-row sm:items-center ]">
				<div className="flex gap-1">
					<GovSkeleton
						width="41px"
						height="20px"
						aria-label={t('loading.wcag.processing')}
					/>
					<GovSkeleton
						width="90px"
						height="20px"
						aria-label={t('loading.wcag.processing')}
					/>
				</div>
				<GovSkeleton
					width="20px"
					height="20px"
					aria-label={t('loading.wcag.processing')}
				/>
				<div className="flex gap-1">
					<GovSkeleton
						width="88px"
						height="20px"
						aria-label={t('loading.wcag.processing')}
					/>
					<GovSkeleton
						width="80px"
						height="20px"
						aria-label={t('loading.wcag.processing')}
					/>
				</div>
			</div>
		</div>
	);
};
export const IdentityDocumentListSkeleton = () => {
	const { t } = useGlobalLocale();
	return (
		<LayoutGap gap="m">
			<div className="flex items-start gap-4 mb-4">
				<GovSkeleton
					height="40px"
					aria-label={t('loading.wcag.processing')}
					width={generateRandomNumber(80, 120) + 'px'}
					className="mb-0 pb-0"
				/>
				<GovSkeleton
					height="40px"
					aria-label={t('loading.wcag.processing')}
					width={generateRandomNumber(50, 100) + 'px'}
					className="mb-0 pb-0"
				/>
			</div>
			<DocumentSkeleton />
			<DocumentSkeleton />
		</LayoutGap>
	);
};
